import { assign, createMachine } from "xstate";

import { CatImport, CatImportRst } from "../types/category";

interface CatImportContext {
  cats: CatImport[];
  rst: CatImportRst[];
}

const assingCats = assign({
  cats: (context, event: any) => event.cats,
});

const assignRst = assign({
  rst: (context, event: any) => event.rst,
});

export const catImportMachine = createMachine(
  {
    id: "CatImport",
    initial: "init",
    predictableActionArguments: true,
    schema: {
      context: {} as CatImportContext,
    },
    context: {
      cats: null as any,
      rst: null as any,
    },
    states: {
      init: {
        on: {
          SELECT_FILE: {
            target: "list",
            actions: ["assingCats"],
          },
        },
      },
      list: {
        on: {
          UPLOAD: {
            target: "uploading",
          },
          BACK: {
            target: "init",
          },
        },
      },
      uploading: {
        on: {
          COMPLETED: {
            target: "completed",
            actions: ["assignRst"],
          },
        },
      },
      completed: {},
    },
  },
  {
    actions: { assingCats, assignRst },
  }
);
